// extracted by mini-css-extract-plugin
export var dropdownButton = "_4g-0";
export var fullWidthDropdownButton = "_4g-1";
export var icon = "_4g-3";
export var iconPlaceholder = "_4g-2";
export var menuItemRow = "_4g-9";
export var separator = "_4g-e";
export var shortcutContainer = "_4g-7";
export var shortcutContainerFilled = "_4g-8";
export var shortcutIconLg = "_4g-6";
export var shortcutIconMd = "_4g-5";
export var shortcutIconSm = "_4g-4";
export var submenuChevron = "_4g-d";
export var submenuDropdown = "_4g-a";
export var submenuTriggerRow = "_4g-b";
export var submenuTriggerRowOpen = "_4g-c";